<script lang="ts">
    import lang from '../../lang/language';
    import Card from "./Card.svelte";
    import CardSkeleton from "./CardSkeleton.svelte";
    import MapPlaceholder from "../../shared_components/MapPlaceholder.svelte";
    import Map from "../../shared_components/Map.svelte";
    import Button from "../../shared_components/controls/Button.svelte";
    import UnderMaintenance from "../../shared_components/UnderMaintenance.svelte";
    import serviceStore from '../../store/service';
import { mapZoom } from '../../helpers/consts';

     let services: any = serviceStore.data;
    let serviceCount: any = serviceStore.data.count;
    let isLoading = serviceStore.data.isLoading;
    let showMap = false;
    let isLoadingMore;
    let noMoreDataToLoad;

    $: isLoadingMore = $isLoading && $services.length !== 0;
    $: noMoreDataToLoad = $services.length === $serviceCount;

    type TabType = 'rate' | 'map';
    let activeTab: TabType = 'rate';


</script>

<div class='display-wrapper'>
    <div class='display-type'>
        <div class={'clickable ' + (activeTab === 'rate' && 'active')}
             on:click={() => activeTab = 'rate'}
        >
            {lang.rate}
        </div>
        <div class={'clickable ' + (activeTab === 'map' && 'active')}
             on:click={() => activeTab = 'map'}
        >
            {lang.map}
        </div>
    </div>
    <div class={'display-rate ' +  (activeTab === 'rate' && 'active')}>
        <div class='service-wrapper'>
            {#each $services as service}
                <Card {service} />
            {/each}
            {#if $isLoading && $services.length === 0}
                <CardSkeleton numberOfSkeleton={12} />
            {/if}
        </div>
        {#if (!$isLoading && $services.length === 0)}
            <UnderMaintenance/>
        {/if}
    </div>
    <div class={'display-map ' +  (activeTab === 'map' && 'active')}>
        {#if $isLoading && $services.length === 0}
            <MapPlaceholder />
        {:else}
            <Map zoomMap={mapZoom} services={$services} />
        {/if}
    </div>
</div>
<div class='row text-center' style='margin-top: 40px'>
    <Button primary
            loading={isLoadingMore}
            hidden={noMoreDataToLoad}
            onClick={serviceStore.getNextPage}
            classList={['load-more']}>
        {#if isLoadingMore}
            {lang.loading}
        {:else}
            {lang.load_more}
        {/if}
    </Button>
</div>

<style>
    .service-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 25px;
        margin-top: 30px;
        /*padding: 5px;*/
    }

    @media screen and (max-width: 900px) {
        .service-wrapper {
            grid-template-columns: repeat(2, 1fr);
        }
    }


    @media screen and (max-width: 600px) {
        .service-wrapper {
            grid-template-columns: 1fr;
        }
    }

    .display-type {
        display: flex;
        flex-direction: row;
        gap: 5px;
        border-bottom: 3px solid var(--primary-color);
        margin-top: 10px;
    }

    .display-type > div {
        padding: 10px 20px;
        border: 0px;
        color: var(--primary-color);
        font-size: 1.1rem;
        transform: translateY(1px);
    }

    .display-type > div.active {
        background-color: var(--primary-color);
        color: #ffffff;
        border: 2px solid var(--primary-color);
        border-bottom: 0px;
    }

    .display-rate, .display-map {
        display: none;
    }

    .display-map {
        padding: 20px 10px;
    }

    .display-rate.active,
    .display-map.active {
        display: block;
    }

    :global(.load-more) {
        max-width: 200px;
        text-align: left;
        display: inline-block;
        height: 50px;
        display: inline-block;
    }
</style>